export default function FeatureImage({ index, img, title }) {
  return (
    <div className={`col-md-7  mb-4 mb-md-0 ${index % 2 === 0 ? "offset-xxl-1" : "order-md-2"}`}>
      <img className="rounded-5" src={img} width="700" alt={title} />
    </div>
  )
}